import React from 'react';

const telNum = '1-800-842-4271';
const auditContactEmail = 'auditcs@travelers.com';

const trvWebLegalLink = (
    <>
        <a href="https://www.travelers.com/w3c/legal/" target="_blank" rel="noopener noreferrer">
            Web Site Usage Agreement Terms and Conditions
        </a>{' '}
    </>
);

const emailLink = (
    <>
        <a href={`mailto:${auditContactEmail}`}>{auditContactEmail}</a>
    </>
);

const legalTxt = (
    <>
        This agreement and the {trvWebLegalLink} found on{' '}
        <a href="https://www.travelers.com/" target="_blank" rel="noopener noreferrer">
            travelers.com
        </a>{' '}
        set forth the terms and conditions under which The Travelers Indemnity Company
        (&quot;Travelers&quot; or &quot;we&quot;) provides the availability of this ePHR site as
        well as the terms and conditions governing your use of this site (&quot;Terms and
        Conditions&quot;). This site is offered to certain commercial policyholders of Travelers and
        its property casualty insurance affiliates and subsidiaries (&quot;Policyholder&quot;) and
        authorized representatives of said Policyholders for purposes of, and relating to, the
        electronic submission of its Electronic Policyholder Report.{' '}
        <span className={'terms-para-header'}>
            <br></br>BY USING THIS WEBSITE, YOU HEREBY AGREE TO BE BOUND TO AND ABIDE BY EACH OF THE
            TERMS AND CONDITIONS THAT APPEAR HERE AND ON{' '}
            <a href="https://www.travelers.com/" target="_blank" rel="noopener noreferrer">
                TRAVELERS.COM
            </a>
            . IF YOU DO NOT AGREE WITH ANY OF THESE PROVISIONS, PLEASE DO NOT USE THIS SITE. YOU MAY
            CONTACT A SERVICE REPRESENTATIVE OF TRAVELERS WITH ANY QUESTIONS THAT YOU MIGHT HAVE
            REGARDING USAGE OR ALTERNATIVE PAPER SUBMISSIONS.
        </span>
    </>
);

const siteUser = (
    <>
        <span className={'terms-para-header'}>&quot;You&quot;</span> and{' '}
        <span className={'terms-para-header'}>&quot;Your&quot;</span> means site user. You represent
        and warrant that you are the Policyholder, an authorized employee of the Policyholder or an
        authorized representative of the Policyholder with approved, verifiable access to use this
        site by the Policyholder.
    </>
);

const userId = (
    <>
        <span className={'terms-para-header'}>User Id and Password.</span> You are required to use a
        user identification (&quot;User Id&quot;) and password for access. You are responsible for
        all activities executed under your User Id. You are responsible for protecting your User Ids
        and passwords from disclosure to any unauthorized employee, representative or third party
        and you are not permitted to avoid the use of required encryption technologies. It is a
        violation of these Terms and Conditions for you to permit an unauthorized person to use your
        User Id and its associated password or attempt to gain access to resources for which you are
        not authorized.
    </>
);

const emailAddressTxt = (
    <>
        <span className={'terms-para-header'}>Use of Your Email Address.</span> You consent to
        receive certain correspondence in relation to the Electronic Policyholder Report(s),
        supporting documentation and use of this site, electronically from Travelers utilizing the
        email address you have provided. These email messages may include, but are not limited to,
        requests for additional information or clarification from a Travelers Premium Audit
        Representative as to the completion of the Electronic Policyholder Report, notices that
        electronic documents are available for viewing on-line, or notices related to site
        registration by the Policyholder or its authorized representative. You agree to provide
        Travelers with your current email address and to update this information, as the need
        arises. To update this information or if you wish to discontinue receiving electronic
        communications, you may do so by contacting {telNum}
        or by email at {emailLink}.
    </>
);

const eSignDetails = (
    <>
        <span className={'terms-para-header'}>Electronic Signature.</span> In order to complete the
        submission of the Electronic Policyholder Report, you will be required to provide an
        electronic signature attestation. You represent and warrant that the email address you
        provide is unique to the person using it, capable of verification, under the sole control of
        the person using it, associated with the data contained within the audit documents in such a
        manner that authenticates the attachment of your electronic identifier or electronic
        signature to the particular data and integrity of the data transmitted, and access to this
        site and related data, and the electronic process or symbol is intended by you to have the
        same force and effect as the use of a signature affixed by hand.
    </>
);

const eDocsDetails = (
    <>
        <span className={'terms-para-header'}>Electronic Documents and System Requirements.</span>{' '}
        Your Electronic Policyholder Report is available for you to view, store and print. In order
        to utilize this site and receive related correspondence electronically, you will need the
        following: access to the Internet, a Web browser, access to a printer if you wish to print
        out a paper copy, a valid email address and a valid User Id and password. You may request a
        paper copy of an Electronic Policyholder Report submission or a blank copy for future paper
        submission without charge by contacting {telNum} or by email at {emailLink}.
    </>
);

const protectingInfo = (
    <>
        <span className={'terms-para-header'}>Protecting Sensitive Information.</span> Sensitive
        information is required for the proper completion of the Policyholder Report. Such
        information may relate to employee income, payroll and other financial, tax or accounting
        records and any other information necessary to enable Travelers to accurately underwrite,
        rate or audit the Policyholder. As such, you agree to maintain the confidentiality of any
        and all information contained within this site and to safeguard the confidentiality of your
        password, access and use of this site in a manner which adequately protects the security and
        integrity of the site and its contents. You agree to access this site for approved business
        purposes only. You shall immediately notify Travelers of any breach of the confidentiality
        or security measures required under this Terms and Conditions document.
    </>
);

const fraudPara = (
    <>
        <span className={'terms-para-header'}>Fraud.</span> The registration or submission of
        information containing false, misleading or incomplete information with the purpose of
        avoiding or reducing the amount of premiums due can be a crime under state or federal law.
    </>
);

const terminationAccessRestrictInfo = (
    <>
        <span className={'terms-para-header'}>Termination and Access Restriction.</span> We may
        terminate, change, suspend or discontinue any aspect of the web site, including the
        availability of any features of the web site and your access to the web site, at any time.
        If you wish to terminate the access of your representative, you may do so by contacting
        {telNum} or by email at {emailLink}.
    </>
);

const indemnificationDetails = (
    <>
        <span className={'terms-para-header'}>Indemnification.</span> You agree to indemnify and
        hold Travelers and its property casualty insurance subsidiaries and affiliates harmless from
        any and all liabilities, losses, damages, fines, penalties, expenses and costs, including,
        without limitation, reasonable attorney&apos;s fees, which we shall suffer, incur or pay
        out, in connection with any failure by you to comply with the Terms and Conditions. This
        paragraph shall survive termination.
    </>
);

const webSiteUsageAgreement = (
    <>
        <span className={'terms-para-header'}>
            Travelers.com Web Site Usage Agreement Terms and Conditions.
        </span>{' '}
        The {trvWebLegalLink}
        page located on travelers.com is hereby incorporated herein by reference. It acts as a
        supplement to the terms and conditions specific to ePHR, set forth herein. To the extent of
        any conflict between the {trvWebLegalLink}
        page located on travelers.com and the terms and conditions specific to ePHR set forth
        herein, the terms and conditions specific to ePHR will prevail, but only to the extent of
        resolving said conflict or inconsistency.
    </>
);

const TermsConditionsDetails = () => {
    return (
        <div className={'terms-details'}>
            <p>{legalTxt}</p>
            <p>{siteUser}</p>
            <p>{userId}</p>
            <p>{emailAddressTxt}</p>
            <p>{eSignDetails}</p>
            <p>{eDocsDetails}</p>
            <p>{protectingInfo}</p>
            <p>{fraudPara}</p>
            <p>{terminationAccessRestrictInfo}</p>
            <p>{indemnificationDetails}</p>
            <p>{webSiteUsageAgreement}</p>
        </div>
    );
};

export default TermsConditionsDetails;
